export default Object.freeze({
  SESSION_ID_STORAGE_KEY: 'session_id',
  SESSION_ID_CUSTOMER: 'customer_id',
  SESSION_ID_MSW: 'MSW_CONFIG',
});
